import gallery from './src/main.vue';
import { withInstall } from '../../utils';
export const Gallery = withInstall(gallery);
export default Gallery;
